module.exports = __webpack_public_path__ + "img/edit3.96c1044b.png";